import Masthead from './Masthead';
export default Masthead;



// WEBPACK FOOTER //
// ./src/components/Masthead/index.js